/**
 * Pure decision logic for the Connections delete confirmation dialog.
 * Kept out of the component so Vitest can lock the rules without a DOM.
 *
 * House rule (mirrors DeleteNetworkDialog): destructive deletes require the
 * user to TYPE the resource's name — a browser ``window.confirm`` is too easy
 * to dismiss by reflex. Match is exact after trimming (names can contain
 * spaces and unicode; we do not lowercase — the displayed name is the token).
 */

/** True when the typed token exactly matches the connection name (trimmed). */
export function confirmMatchesConnectionName(typed, name) {
  const a = String(typed ?? '').trim();
  const b = String(name ?? '').trim();
  return a.length > 0 && a === b;
}

/** Gate for the destructive submit button. */
export function canSubmitConnectionDelete({ name, typedConfirm, submitting }) {
  if (submitting) return false;
  return confirmMatchesConnectionName(typedConfirm, name);
}
